import {
    Directive,
    ElementRef,
    HostBinding,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { BrandingService } from '../../services/branding.service';

@Directive({
    selector: '[proLogoImg]',
})
export class ProLogoImgDirective implements OnInit, OnDestroy {
    @HostBinding('src') imageSource;
    private logoSrcSubscriber: Subscription;
    private ALT_TEXT = 'logo';

    constructor(
        private readonly element: ElementRef,
        private readonly brandingService: BrandingService
    ) {
        this.element.nativeElement.setAttribute('alt', this.ALT_TEXT);
    }

    ngOnInit(): void {
        this.logoSrcSubscriber = this.brandingService.logoSubscriber.subscribe((srcLogoUrl: string) => {
                this.imageSource = srcLogoUrl;
            }
        );
    }

    ngOnDestroy(): void {
        if (this.logoSrcSubscriber) {
            this.logoSrcSubscriber.unsubscribe();
        }
    }
}
